import Main from './Main.vue'
import Popups from './components/Popups'
import NovoPopup from './components/NovoPopup'

export default [{
  path: 'popup',
  name: 'popup',
  component: Main,
  children: [
    {path: '/', component: Popups, name: 'popup.lista'},
    {path: 'registrar', component: NovoPopup, name: 'popup.novo'},
    {path: ':id', component: NovoPopup, name: 'popup.edit'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/popup/routes.js